import type { ButtonProps } from '@mui/material'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { memo } from 'react'

type Props = ButtonProps

const SubmitButton = ({ children, ...props }: Props) => {
  const { t } = useTranslation()
  return (
    <Button type="submit" color="primary" {...props}>
      {children ?? t('common.save')}
    </Button>
  )
}

export default memo(SubmitButton)
